import zh from './zh'
import tw from './tw'
import en from './en'

export default {
  zh,
  tw,
  en,
}



// WEBPACK FOOTER //
// ./src/assets/scripts/i18n/index.js